var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.facility=='app')?_c('div',{class:_vm.facility=='app'?'content':''},[_c('Applogin')],1):_c('div',[_c('Pnav'),_c('div',{staticClass:"height"}),_c('router-view'),_c('Pfooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }